import { nanoid } from "nanoid";

export type Id = string;

export function newId(): Id {
  return nanoid();
}